import { render, staticRenderFns } from "./Notfound.vue?vue&type=template&id=5dd3d8a1"
import script from "./Notfound.vue?vue&type=script&lang=js"
export * from "./Notfound.vue?vue&type=script&lang=js"
import style0 from "./Notfound.vue?vue&type=style&index=0&id=5dd3d8a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports